import { render, staticRenderFns } from "./areaAndClassify.vue?vue&type=template&id=0dbae208&scoped=true&"
import script from "./areaAndClassify.vue?vue&type=script&lang=js&"
export * from "./areaAndClassify.vue?vue&type=script&lang=js&"
import style0 from "./areaAndClassify.vue?vue&type=style&index=0&id=0dbae208&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dbae208",
  null
  
)

export default component.exports